const initialState = {
    reset: false,
    isAuthenticated: false,
    hasSubscribed: false,
  };
  
  export const chatbotReducer = (state = initialState, action) => {
    switch (action.type) {
      case 'RESET_CHATBOT':
        console.log(`
  🔄 RESET_CHATBOT Action Dispatched
  ------------------------------------
  Previous State:`, state, `
  Action Payload:`, action.payload, `
  ------------------------------------
  `);
  
        return {
          ...state,
          reset: !state.reset, // Toggle reset
          isAuthenticated: action.payload?.isAuthenticated ?? state.isAuthenticated, // Retain current state if payload is missing
          hasSubscribed: action.payload?.hasSubscribed ?? state.hasSubscribed, // Retain current state if payload is missing
        };
  
      default:
        return state;
    }
  };
  